<template>
    <div class="uni-exam-wrap exemptionApplication">
        <div class="uni-exam-pay">
            <div class="continer">
                <Title text="免考申请"></Title>
                <div>
                    <el-form
                        ref="search"
                        :inline="true"
                        :model="condition"
                        :rules="searchRules"
                        class="search-form"
                        slot="search"
                        label-width="80px"
                    >
                        <div style="display: flex; justify-content: space-between">
                            <div>
                            </div>
                            <div>
                                <div class="btn-box">
                                    <div>
                                        <el-form-item>
                                            <el-button type="primary" @click="exemptionApplicationClick">免考申请</el-button>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="elTabs">
                    <div class="informationDiv">
                        <el-table :data="dataList" headerRowClassName="uni-primary-table-header" stripe border>
                            <el-table-column prop="student_title" align="center" label="学生"></el-table-column>
                            <el-table-column prop="student_code" align="center" label="学号"></el-table-column>
                            <el-table-column prop="class_title" align="center" label="班级"></el-table-column>
                            <el-table-column prop="" align="center" label="免考课程">
                                <template slot-scope="{row}">
                                    <el-button type="text" size="mini" @click="courseClick(row)">查看课程</el-button>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="" align="center" label="毕业证照片">
                                <template slot-scope="{row}">
                                    <div v-if="!$base.isNull(row.diploma_img)">
                                        <el-image
                                            class="see-img"
                                            v-for="(item, index) in row.diploma_img.split(',')"
                                            :key="index"
                                            :src="item"
                                            :preview-src-list="row.diploma_img.split(',')"
                                            style="margin-right: 2px;">
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="" align="center" label="成绩单照片">
                                <template slot-scope="{row}">
                                    <div v-if="!$base.isNull(row.transcript_img)">
                                        <el-image
                                            class="see-img"
                                            v-for="(item, index) in row.transcript_img.split(',')"
                                            :key="index"
                                            :src="item"
                                            :preview-src-list="row.transcript_img.split(',')"
                                            style="margin-right: 2px;">
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" align="center" label="身份证国徽面">
                                <template slot-scope="{row}">
                                    <el-image
                                        v-if="!$base.isNull(row.identity_pros)"
                                        class="see-img"
                                        :src="row.identity_pros"
                                        :preview-src-list="[row.identity_pros]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" align="center" label="身份证人像面">
                                <template slot-scope="{row}">
                                    <el-image
                                        v-if="!$base.isNull(row.identity_cons)"
                                        class="see-img"
                                        :src="row.identity_cons"
                                        :preview-src-list="[row.identity_cons]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" align="center" label="手写签名">
                                <template slot-scope="{row}">
                                    <img :src="row.sign_img" alt="" style="height: 40px;object-fit: contain;">
                                    <!-- <el-image
                                        v-if="!$base.isNull(row.sign_img)"
                                        class="see-img"
                                        :src="row.sign_img"
                                        :preview-src-list="[row.sign_img]">
                                    </el-image> -->
                                </template>
                            </el-table-column>
                            <el-table-column prop="apply_remark" align="center" label="申请理由"></el-table-column>
                            <el-table-column prop="first_check_status" align="center" label="初审状态">
                                <template slot-scope="{row}">
                                    <el-tag :type="row.first_check_status | auditStatusStyle">
                                        <span>{{row.first_check_status | auditStatusFilter}}</span>
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="first_check_remarks" align="center" label="初审备注"></el-table-column>
                            <el-table-column prop="is_check" align="center" label="终审状态">
                                <template slot-scope="{row}">
                                    <el-tag :type="row.is_check | auditStatusStyle">
                                        <span>{{row.is_check | auditStatusFilter}}</span>
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="check_remark" align="center" label="终审备注"></el-table-column>
                            <el-table-column align="center" width="100" label="操作">
                                <template slot-scope="{row}">
                                    <el-button v-if="row.first_check_status == 0" size="small" style="font-size: 12px" type="primary" @click="editClick(row)">修改</el-button>
                                    <span v-else>--</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>

                <!-- 免考课程 -->
                <el-dialog
                    class="exemptionCoursesPop"
                    title="免考课程"
                    :visible.sync="isShowExemptionCoursesPop"
                    width="60%"
                >
                    <div class="dialog">
                        <el-table :data="exemptionCoursesList" stripe border>
                        <el-table-column prop="course_title" align="center" label="课程名称"></el-table-column>
                        <!-- <el-table-column prop="credit" align="center" label="学分"></el-table-column> -->
                        <el-table-column prop="final_score" align="center" label="总评成绩"></el-table-column>
                        <el-table-column prop="score_source" align="center" label="成绩来源"></el-table-column>
                    </el-table>
                    </div>
                    <div style="text-align: center;margin-top: 20px;">
                        <el-button @click="isShowExemptionCoursesPop = false">取 消</el-button>
                    </div>
                </el-dialog>

                <!-- 免考申请 -->
                <el-dialog
                    class="exemptionApplicationPop"
                    title="免考申请"
                    :visible.sync="isShowExemptionApplicationPop"
                    width="60%"
                    @close="exemptionApplicationPopClose"
                >
                    <div class="dialog">
                        <el-form
                            ref="exemptionApplicationPop"
                            :model="exemptionApplicationPopData"
                            :rules="exemptionApplicationPopRules"
                            label-width="120px"
                        >
                            <div class="flex">
                                <el-form-item label="姓名" prop="title" style="width: 30%;">
                                    <el-input v-model="exemptionApplicationPopData.title" disabled placeholder="姓名"></el-input>
                                </el-form-item>
                                <el-form-item label="学号" prop="student_code" style="width: 30%;">
                                    <el-input v-model="exemptionApplicationPopData.student_code" disabled placeholder="学号"></el-input>
                                </el-form-item>
                                <el-form-item label="班级" prop="className" style="width: 30%;">
                                    <el-input v-model="exemptionApplicationPopData.className" disabled placeholder="班级"></el-input>
                                </el-form-item>
                            </div>
                            <div class="flex" v-for="(item, index) in exemptionApplicationPopData.course_data" :key="index">
                                <el-form-item label="免考课程" :prop="`course_data.${index}.course_id`" :rules="{ required: true, message: '请选择免考课程' }">
                                    <el-select
                                        v-model="item.course_id"
                                        placeholder="请选择免考课程"
                                        clearable
                                        filterable
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in courseList"
                                            :key="item.id"
                                            :label="item.title"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="学分" :prop="`course_data.${index}.credit`" :rules="{ required: true, message: '请输入学分' }" style="width: 20%;">
                                    <el-input v-model="item.credit" type="number" placeholder="学分"></el-input>
                                </el-form-item>
                                <el-form-item label="总评成绩" :prop="`course_data.${index}.final_score`" :rules="{ required: true, message: '请输入总评成绩' }" style="width: 20%;">
                                    <el-input v-model="item.final_score" type="number" placeholder="总评成绩"></el-input>
                                </el-form-item>
                                <el-form-item label="成绩来源" :prop="`course_data.${index}.score_source`" :rules="{ required: true, message: '请输入成绩来源' }" style="width: 20%;">
                                    <el-input v-model="item.score_source" placeholder="成绩来源"></el-input>
                                </el-form-item>
                                <div class="btn-box">
                                    <i v-if="index == exemptionApplicationPopData.course_data.length - 1" class="el-icon-circle-plus-outline btn btn-add" style="color: #5879ff"  @click="addCourseClick"></i>
                                    <i v-if="index > 0" class="el-icon-remove-outline btn btn-del" @click="removeCourse(index)"></i>
                                </div>
                            </div>
                            <!-- <div>
                                <el-form-item label="毕业证照片" prop="diploma_img">
                                    <FalConUpload
                                        ref="uploadDiplomaImg"
                                        :multiple="true"
                                        :isShowModal="false"
                                        :limit="9"
                                        @handleRemove="diplomaImgRemove"
                                        @handleChange="diplomaImgChange"
                                    >
                                    </FalConUpload>
                                </el-form-item>
                            </div> -->
                            <div>
                                <el-form-item label="成绩单照片" prop="transcript_img">
                                    <FalConUpload
                                        ref="uploadTranscriptImg"
                                        :multiple="true"
                                        :isShowModal="false"
                                        :limit="9"
                                        :fileListData="exemptionApplicationPopData.transcript_img"
                                        :isFileListData="true"
                                        @handleRemove="transcriptImgRemove"
                                        @handleChange="transcriptImgChange"
                                    >
                                    </FalConUpload>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item label="身份证国徽面" prop="identity_pros">
                                    <FalConUpload
                                        ref="uploadIdentityPros"
                                        :isShowModal="false"
                                        :fileListData="exemptionApplicationPopData.identity_pros"
                                        :isFileListData="true"
                                        @handleRemove="identityProsRemove"
                                        @handleChange="identityProsChange"
                                    >
                                    </FalConUpload>
                                </el-form-item>
                                <el-form-item label="身份证人像面" prop="identity_cons">
                                    <FalConUpload
                                        ref="uploadIdentityCons"
                                        :isShowModal="false"
                                        :fileListData="exemptionApplicationPopData.identity_cons"
                                        :isFileListData="true"
                                        @handleRemove="identityConsRemove"
                                        @handleChange="identityConsChange"
                                    >
                                    </FalConUpload>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item label="手写签名:" prop="sign_img">
                                    <esignHandle
                                        ref="esignHandle"
                                        :selectSignImg.sync="exemptionApplicationPopData.sign_img"
                                        :isShowCurrSignImg="true"
                                    ></esignHandle>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item label="申请理由" prop="apply_remark" style="width: 50%;">
                                    <el-input :rows="3" type="textarea" v-model="exemptionApplicationPopData.apply_remark" resize="none" clearable placeholder="申请理由"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div style="text-align: center">
                        <el-button @click="isShowExemptionApplicationPop = false">取 消</el-button>
                        <el-button type="primary" :loading="exemptionApplicationPopLoading" @click="exemptionApplicationPopSubmit">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import {studentExemptApplyGet, studentGeCourseAll, studentExemptApplyPost, studentExemptApplyCourse} from '@/api/exam';
import FalConUpload from "@/components/uploadFile";
import esignHandle from '@/components/esignHandle';
import { putObject, uploadFiles, deleteObject } from "@/utils/upload";
import {deepClone} from '@/utils/func';
export default {
    name: 'exemptionApplication',
    components: { FalConUpload, esignHandle },
    filters: {
        auditStatusFilter(v){
            const obj = {
                0: '待审核',
                1: '通过', 
                2: '拒绝', 
            };
            return obj[v];
        },
        auditStatusStyle(v){
            const obj = {
                0: '', 
                1: 'success',
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data() {
        return {
            condition: {

            },
            searchRules: {

            },

            dataList: [],

            // 免考申请 弹窗数据
            isShowExemptionApplicationPop: false,
            exemptionApplicationPopData: {
                title: '',  //学生姓名
                student_code: '', //学号
                className: '',  //班级
                //免考课程
                course_data: [
                    {
                        course_id: '',  //课程id
                        credit: '',   //学分
                        final_score: '',  //总评成绩
                        score_source: '',  //成绩来源
                    },
                ],
                // diploma_img: '',  //毕业证照片
                transcript_img: '',  //成绩单照片
                identity_pros: '',  //身份证国徽面
                identity_cons: '',  //身份证人像面
                sign_img: '',  //手写签名
                apply_remark: '',  //申请理由
            },
            exemptionApplicationPopRules: {
                // diploma_img: [{ required: true, message: '请选择毕业证照片', trigger: 'change' }],
                transcript_img: [{ required: true, message: '请选择成绩单照片', trigger: 'change' }],
                identity_pros: [{ required: true, message: '请选择身份证国徽面', trigger: 'change' }],
                identity_cons: [{ required: true, message: '请选择身份证人像面', trigger: 'change' }],
                sign_img: [{ required: true, message: '请选择手写签名', trigger: 'change' }],
                apply_remark: [{ required: true, message: '请填写申请理由', trigger: 'blur' }],
            },
            courseList: [], //课程列表
            exemptionApplicationPopLoading: false,  //弹窗 免考申请 提交等待

            // 免考课程 弹窗
            isShowExemptionCoursesPop: false,
            exemptionCoursesList: [],
        };
    },
    computed: {
        ...mapState("permission", {
            userInfo: state => JSON.parse(state.userInfo),
        }),
        ...mapState("common", {
            className: state => state.studentMajor.className,
        }),
    },
    created() {

        this.getListFn();

        // 添加学生初始信息
        let title = this.userInfo.title;
        let student_code = this.userInfo.student_code;
        let className = this.className;
        this.exemptionApplicationPopData.title = title;
        this.exemptionApplicationPopData.student_code = student_code;
        this.exemptionApplicationPopData.className = className;

        this.getCourseList();
    },
    mounted() {},
    methods: {
        // 修改
        async editClick(row){
            const {
                id,
                // course_data,
                // diploma_img,
                transcript_img,
                identity_pros,
                identity_cons,
                sign_img,
                apply_remark,
            } = row;
            this.exemptionApplicationPopData['id'] = row.id;
            // this.exemptionApplicationPopData['course_data'] = course_data;
            this.exemptionApplicationPopData['transcript_img'] = transcript_img;
            this.exemptionApplicationPopData['identity_pros'] = identity_pros;
            this.exemptionApplicationPopData['identity_cons'] = identity_cons;
            this.exemptionApplicationPopData['sign_img'] = sign_img;
            this.exemptionApplicationPopData['apply_remark'] = apply_remark;

            let data = {
                exempt_apply_id: row.id
            };
            const res = await studentExemptApplyCourse(data);
            if(res.code == 200){
                this.exemptionApplicationPopData['course_data'] = res.result;
            }

            this.isShowExemptionApplicationPop = true;
        },
        // 点击查看课程
        courseClick(row){
            let data = {
                exempt_apply_id: row.id
            };
            studentExemptApplyCourse(data).then(res => {
                if(res.code == 200){
                    this.exemptionCoursesList = res.result;
                    this.isShowExemptionCoursesPop = true;
                }
            });
        },
        // 弹窗 免考申请 提交
        exemptionApplicationPopSubmit(){
            this.$refs["exemptionApplicationPop"].validate((valid) => {
                if (valid) {
                    this.exemptionApplicationPopLoading = true;
                    // let P1 = new Promise((resolve, reject) => {
                    //     uploadFiles(this.exemptionApplicationPopData.diploma_img, (url) => {
                    //         resolve(url);
                    //     })
                    // })
                    let P2 = new Promise((resolve, reject) => {
                        uploadFiles(this.exemptionApplicationPopData.transcript_img, (url) => {
                            resolve(url);
                        })
                    })
                    let P3 = new Promise((resolve, reject) => {
                        putObject(this.exemptionApplicationPopData.identity_pros, (url) => {
                            resolve(url);
                        })
                    })
                    let P4 = new Promise((resolve, reject) => {
                        putObject(this.exemptionApplicationPopData.identity_cons, (url) => {
                            resolve(url);
                        })
                    })
                    // P1, 
                    Promise.all([P2, P3, P4]).then(res => {
                        const exemptionApplicationPopData = deepClone(this.exemptionApplicationPopData);
                        let {id, course_data, sign_img, apply_remark} = exemptionApplicationPopData;
                        let data = {
                            // diploma_img: res[0],
                            transcript_img: res[0],
                            identity_pros: res[1],
                            identity_cons: res[2],
                            course_data: JSON.stringify(course_data),
                            sign_img,
                            apply_remark,
                        };
                        if(id){
                            data.id = id;
                        }
                        studentExemptApplyPost(data).then(ress => {
                            if(ress.code == 200){
                                this.$message.success('操作成功');
                                this.isShowExemptionApplicationPop = false;
                                this.getListFn();
                            }
                        }).finally(() => {
                            this.exemptionApplicationPopLoading = false;
                        });
                    });

                }
            })
        },
        // 弹窗 免考申请 关闭
        exemptionApplicationPopClose(){
            this.exemptionApplicationPopData = {
                title: this.userInfo.title,  //学生姓名
                student_code: this.userInfo.student_code, //学号
                className: this.className,  //班级
                //免考课程
                course_data: [
                    {
                        course_id: '',  //课程id
                        credit: '',   //学分
                        final_score: '',  //总评成绩
                        score_source: '',  //成绩来源
                    },
                ],
                apply_remark: '',  //申请理由
                // diploma_img: '',  //毕业证照片
                transcript_img: '',  //成绩单照片
                identity_pros: '',  //身份证国徽面
                identity_cons: '',  //身份证人像面
                sign_img: '',  //手写签名
            };
            // this.$refs['uploadDiplomaImg'].reset();
            this.$refs['uploadTranscriptImg'].reset();
            this.$refs['uploadIdentityPros'].reset();
            this.$refs['uploadIdentityCons'].reset();
            this.$refs['esignHandle'].handleReset();  //签名这块清空
            this.$nextTick(() => {
                this.$refs["exemptionApplicationPop"].clearValidate();
            });
        },
        // 点击 删除课程
        removeCourse(index){
            this.exemptionApplicationPopData.course_data.splice(index, 1);
        },
        // 点击 新增课程
        addCourseClick(){
            this.exemptionApplicationPopData.course_data.push({
                course_id: '',  //课程id
                credit: '',   //学分
                final_score: '',  //总评成绩
                score_source: '',  //成绩来源
            });
        },
        // 点击免考申请
        exemptionApplicationClick(){
            this.isShowExemptionApplicationPop = true;
        },
        // 弹窗 免考申请 上传 毕业证照片
        // diplomaImgChange(data) {
        //     this.exemptionApplicationPopData.diploma_img = data.fileList;
        // },
        //  弹窗 免考申请 删除 毕业证照片
        // diplomaImgRemove(data) {
        //     this.exemptionApplicationPopData.diploma_img = data.fileList;
        // },
        // 弹窗 免考申请 上传 成绩单照片
        transcriptImgChange(data) {
            this.exemptionApplicationPopData.transcript_img = data.fileList;
        },
        //  弹窗 免考申请 删除 成绩单照片
        transcriptImgRemove(data) {
            this.exemptionApplicationPopData.transcript_img = data.fileList;
        },
        // 弹窗 免考申请 上传 身份证国徽面
        identityProsChange(data) {
            this.exemptionApplicationPopData.identity_pros = data.file;
        },
        //  弹窗 免考申请 删除 身份证国徽面
        identityProsRemove(data) {
            this.exemptionApplicationPopData.identity_pros = data.file;
        },
        // 弹窗 免考申请 上传 身份证人像面
        identityConsChange(data) {
            this.exemptionApplicationPopData.identity_cons = data.file;
        },
        //  弹窗 免考申请 删除 身份证人像面
        identityConsRemove(data) {
            this.exemptionApplicationPopData.identity_cons = data.file;
        },
        // 获取学生要学的全部课程
        getCourseList(){
            studentGeCourseAll().then(res => {
                if(res.code == 200){
                    this.courseList = res.result;
                }
            });
        },
        // 获取数据
        getListFn(){
            studentExemptApplyGet().then(res => {
                if(res.code == 200){
                    this.dataList = res.result;
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.exemptionApplication{
    min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
    .uni-exam-pay {
        min-height: inherit;
        background: #fff;
        .continer {
            height: 100%;
            //overflow: hidden;
            padding: 0 20px 20px;
        }
    }
    .btn-box{
        margin-left: 10px;
        .btn{
            font-size: 20px;
            margin-top: 10px;
            cursor: pointer;
            &.bnt-add{
                color: #2E58FF;
            }
            &.btn-del{
                color: #e85f64;
                margin-left: 10px;
            }
        }
    }
    .flex{
        display: flex;
    }
    .see-img{
        width: 50px;
    }
}
</style>
